import { defineComponent as _defineComponent } from 'vue'
import { TUITranslateService, TUIGlobal } from "@tencentcloud/chat-uikit-engine";
import {
  defineProps,
  watchEffect,
  ref,
  defineEmits,
} from "../../../adapter-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'manage-notification',
  props: {
  data: {
    type: Object,
    default: () => ({}),
  },
  isAuthor: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update", "toggleEdit"],
  setup(__props, { emit: emits }) {

const props = __props



const groupProfile = ref({});
const input = ref("");
const isAuthorNotification = ref(false);
const isEdit = ref(false);
const isUniFrameWork = ref(typeof uni !== 'undefined');

watchEffect(() => {
  groupProfile.value = props.data;
  input.value = groupProfile.value.notification;
  isAuthorNotification.value = props.isAuthor;
});



// 更新群资料
const updateProfile = () => {
  if (input.value && input.value !== groupProfile.value.notification) {
    emits("update", { key: "notification", value: input.value });
    groupProfile.value.notification = input.value;
    input.value = "";
  }
  isEdit.value = !isEdit.value;
};

const toggleEdit = async (tabName: string) => {
  emits("toggleEdit", tabName);
};

return { __sfc: true,props, groupProfile, input, isAuthorNotification, isEdit, isUniFrameWork, emits, updateProfile, toggleEdit, TUITranslateService }
}

})